import { render, staticRenderFns } from "./BookInfo.vue?vue&type=template&id=87b02bfa&scoped=true&"
import script from "./BookInfo.vue?vue&type=script&lang=js&"
export * from "./BookInfo.vue?vue&type=script&lang=js&"
import style0 from "./BookInfo.vue?vue&type=style&index=0&id=87b02bfa&scoped=true&lang=css&"
import style1 from "./BookInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b02bfa",
  null
  
)

export default component.exports